import { render } from "./BaseMenuCard.vue?vue&type=template&id=2df43aeb&scoped=true"
import script from "./BaseMenuCard.vue?vue&type=script&lang=js"
export * from "./BaseMenuCard.vue?vue&type=script&lang=js"

import "./BaseMenuCard.vue?vue&type=style&index=0&id=2df43aeb&lang=scss&scoped=true"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df43aeb"],['__file',"resources/js/components/BaseMenuCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2df43aeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2df43aeb', __exports__)) {
    console.log('reload')
    api.reload('2df43aeb', __exports__)
  }
  
  module.hot.accept("./BaseMenuCard.vue?vue&type=template&id=2df43aeb&scoped=true", () => {
    console.log('re-render')
    api.rerender('2df43aeb', render)
  })

}


export default __exports__